import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import RadioInput from 'screens/components/basic/RadioInput';
import TextInput from 'screens/components/basic/TextInput';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
import Button from 'screens/components/basic/Button';
import POSProductDiscount from './POSProductDiscount';
import POSAlpineProductDiscount from './POSAlpineProductDiscount';
import { formInput, formError, initializeStoreDiscount, clearFormErrors } from 'actions/FormActions';
import CheckInput from 'screens/components/basic/CheckInput';
import { selectPOSDiscountModel, selectDiscountProducts } from 'selectors/entitySelector';
import { discountOrder, discountProductsOrder, getCustomizedDiscounts } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import util from 'library/util';

const dialogStyle = {
  width: '65%',
  maxWidth: 'none'
};

class POSDiscountDialog extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      rewardPointDiscountNext: false,
      rewardPointAmount: ""
    };
  }

  componentDidMount() {
    this.props.getCustomizedDiscounts({
      branchId: this.props.branchId
    });
  }

  componentWillReceiveProps = (newProps) => {
    if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
      || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
      // if does changed call the respective action (SUCCESS OR FAILURE)
      if (newProps.saveSuccess === true) {
        this.saveSuccess();
      }
      else if (newProps.saveSuccess === false && newProps.saveError) {
        const errorCode = newProps.saveError.split('-')[0];
        this.saveFailure(errorCode);
      }

    }
    if (this.props.open === false && newProps.open === true) {
      this.props.formInput('1', `${this.props.name}DiscountType`);
    }
    if (newProps.radioSelected != null && newProps.radioSelected != undefined && this.props.radioSelected != newProps.radioSelected) {
      this.props.formInput("", `posDialogDiscountCustomizedDiscountSelection`);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.radioSelected != this.props.radioSelected) {
      this.props.clearFormErrors();
    }
  }

  saveSuccess = () => {
    this.onClose();
    this.props.showSnackbar(this.props.t('pos.discountDialog.saveSuccessMessage'));
  }

  saveFailure = (errorCode) => {
    if (errorCode && errorCode == 9) {
      this.props.showError(this.props.t('pos.discountDialog.invalidCredentialsDiscount'));
    }
    else
      if (errorCode && errorCode == 29) {
        this.props.showError(this.props.t('pos.discountDialog.TotalDiscountBigger'));
      }
      else
        if (errorCode && errorCode == 4) {
          this.props.showError(this.props.t('pos.messages.orderUpdatedElsewhereMessage'))
        }
        else {
          this.props.showError(this.props.t('pos.discountDialog.saveErrorMessage'));
        }
  }

  onClose = () => {
    this.props.onClose();
    this.props.initializeStoreDiscount();
  }

  applyDiscount = () => {
    let model = this.props.model;
    const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
    const { stackDiscountsEnabled, POSDiscountRewardAmount, rewardPointNotes, posDialogDiscountCustomizedDiscountSelection } = this.props
    model.DeviceId = deviceData.id;
    model.orderProductsDiscount = this.props.productDiscounts.filter(item => item.productId && item.type && (item.amount || item.percentage));

    const missingNotes = model.orderProductsDiscount.some(item => !item.orderProductNotes || item.orderProductNotes.trim() === '');
    if (missingNotes && (this.props.isHighTide || this.props.isInspired)) {
      this.props.showError(this.props.t('pos.discountDialog.productDiscountNote'));
      return;
    }

    if (this.props.alpineIQApiKey) {
      let orderDiscountPoints = 0;
      if (this.props.order && this.props.order.discounts) {
        this.props.order.discounts.map((odiscount) => {
          orderDiscountPoints = orderDiscountPoints + odiscount.alpineIQRewardPoints;
        });
      }

      let orderProductDiscountPoints = 0;
      if (this.props.order && this.props.order.products) {
        this.props.order.products.map((product) => {
          orderProductDiscountPoints = orderProductDiscountPoints + product.alpineIQRewardPoints;
        });
      }

      let points = 0;
      for (let discount of model.orderProductsDiscount) {
        points = points + discount.pointsDeduction
      }

      if (points + orderDiscountPoints + orderProductDiscountPoints > this.props.alpineIQPoints) {
        alert(this.props.t('pos.discountDialog.notEnoughAlpinePointsWarning'));
        return;
      }
    }

    model.orderProductsDiscount.map(p => {
      if (p.type == 'Percentage') {
        p.amount = p.percentage;
      }
    });

    let validators = [];
    this.props.clearFormErrors()
    const p = this.props;
    if (model.orderId !== 0) {
      if (p.discountNeedApproval && !posDialogDiscountCustomizedDiscountSelection && !this.props.pinCode) {
        validators.push(
          [p.name + 'Username', d => (d.UserName && d.UserName !== ""), "Username"],
          [p.name + 'Password', d => (d.Password && d.Password !== ""), "Password"]
        )
      }

      // if the discount is for the order add specific validation
      if (this.props.radioSelected == 1 && !posDialogDiscountCustomizedDiscountSelection) {
        if (this.props.isHightide || this.props.isInspired) {
          validators.push([p.name + 'Notes', d => (d.Notes && d.Notes !== ""), "Notes"]);
        }
        if (this.props.isPercentage === true) {
          validators.push([p.name + 'Percentage', d => (d.Percentage && d.Percentage !== "" && d.Percentage !== 0), "Percentage"]);
        } else {
          validators.push([p.name + 'Amount', d => (d.Amount && d.Amount !== "" && d.Amount !== 0), "Amount"]);
        }
      }

      if (stackDiscountsEnabled) {
        model.OrderDiscountVisit = null;
        model.CustomizedDiscountId = 0;
        model.IsFromVisitCount = false;

        const modelConditions = [
          () => posDialogDiscountCustomizedDiscountSelection && (model.Amount = model.Percentage = 0, model.orderProductsDiscount = [], model.IsFromRewardPoints = false, model.RewardPoint = null, model.CustomizedDiscountIds = [posDialogDiscountCustomizedDiscountSelection], true),
          () => this.props.radioSelected == 1 && (model.orderProductsDiscount = [], model.IsFromRewardPoints = false, model.RewardPoint = null, model.CustomizedDiscountIds = [], true),
          () => this.props.radioSelected == 2 && (model.Amount = model.Percentage = 0, model.IsFromRewardPoints = false, model.RewardPoint = null, model.CustomizedDiscountIds = [], true),
          () => this.props.radioSelected == 3 && (model.Amount = model.Percentage = 0, model.orderProductsDiscount = [], model.IsFromRewardPoints = POSDiscountRewardAmount && parseFloat(POSDiscountRewardAmount) !== 0, model.RewardPoint = POSDiscountRewardAmount && parseFloat(POSDiscountRewardAmount) !== 0 ? { Notes: `Reward Points ${rewardPointNotes}`, Amount: parseFloat(POSDiscountRewardAmount) } : null, model.CustomizedDiscountIds = [], true)
        ].some(func => func());

        if (util.validate(validators, model, this.props.formError) && modelConditions) {
          this.props.discountOrder(model);
        }

      } else {
        if (util.validate(validators, model, this.props.formError)) {
          // if the discount is for the order
          if (this.props.radioSelected == 1 || this.props.radioSelected == 3) {
            this.props.discountOrder(model);
          }
          // when discount is applied per product
          else {
            // verify if there is any discount applied for the product
            if (model.orderProductsDiscount && model.orderProductsDiscount.length > 0) {
              this.props.discountProductsOrder(model);
            }
            else {
              this.props.showError(this.props.t('pos.discountDialog.fillProductError'));
            }
          }
        }
      }
    }
  }

  checkDiscountProfit = (orderTotal, discount, checkType, discountType) => {
    let activeProducts = this.props.order.products.filter(x => x.status != 4);
    let totalCost = activeProducts.reduce((total, product) => product.costPrice * product.quantity + total, 0);

    switch (checkType) {
      case "cost":
        if (discountType == "percentage") {
          return ((orderTotal - orderTotal * discount / 100) < totalCost)
        } else {
          return ((orderTotal - discount) < totalCost)
        }
      case "margin":
        if (discountType == "percentage") {
          return ((orderTotal - orderTotal * discount / 100) < totalCost * 1.15)    //15% profit margin
        } else {
          return ((orderTotal - discount) < totalCost * 1.15)
        }
    }
  }

  getDiscountTypeName = (discountType) => {
    switch (discountType) {
      case 1:
        return "percentage"
      case 2:
        return "decimal"
    }
  }

  getDiscountWarningMessage = (orderTotal, discount, discountType) => {
    return (
      this.checkDiscountProfit(orderTotal, discount, "cost", discountType) ?
        <h6 style={{ color: "red" }}>{`${this.props.t('pos.discountDialog.warning')} ${this.props.t('pos.discountDialog.belowCostMessage')}`}</h6> :
        (this.checkDiscountProfit(orderTotal, discount, "margin", discountType) ?
          <h6 style={{ color: "orange" }}>{`${this.props.t('pos.discountDialog.warning')} ${this.props.t('pos.discountDialog.belowMarginMessage')}`}</h6> :
          <h6></h6>)
    )
  }

  clearCustomizedDiscount = () => {
    this.props.formInput(null, `posDialogDiscountCustomizedDiscountSelection`);
  }

  render() {
    const { t } = this.props;
    const p = this.props;
    const radioSelected = p.radioSelected;
    const hasExistingProductDiscount = p.order && p.order.products.filter(item => item.discountType !== null).length > 0;
    let discountOptions = [];
    let maxRewardPointsDiscountAmount = 0;
    let maxDiscountAppliedForOrder = 0;
    let disableOrderDiscount = (!p.stackDiscountsEnabled && p.order && (p.order.discounts.length > 0 || hasExistingProductDiscount));
    const hideBCRewards = this.props.store && this.props.store.provinceState && (this.props.store.provinceState.toLowerCase() == "bc" || this.props.store.provinceState.toLowerCase() == "british columbia") && !this.props.isMedical;
    if (p.order && p.order.patientId && !p.isHighTide) {
      discountOptions = [
        { text: t('pos.discountDialog.orderDiscount'), value: '1', disabled: disableOrderDiscount },
        { text: t('pos.discountDialog.productDiscount'), value: '2' },
        { text: t('pos.discountDialog.rewardsDiscount'), value: '3', disabled: disableOrderDiscount || this.props.hideRewards || hideBCRewards }
      ];

      if (p.order.patientRewardPoints && p.order.patientRewardPoints > p.rewardPointsDivider / 100) {
        maxRewardPointsDiscountAmount = (p.order.patientRewardPoints / this.props.rewardPointsDivider).toFixed(2);
        maxDiscountAppliedForOrder = maxRewardPointsDiscountAmount;
        if (p.order.subTotal < maxRewardPointsDiscountAmount) {
          maxDiscountAppliedForOrder = (p.order.subTotal).toFixed(2);
        }
      }

    } else {
      discountOptions = [
        { text: t('pos.discountDialog.orderDiscount'), value: '1', disabled: disableOrderDiscount },
        { text: t('pos.discountDialog.productDiscount'), value: '2' }
      ];
    }

    let customizedDiscounts = p.customizedDiscounts;
    let customizedDiscountOptions = [];
    customizedDiscounts.map(d => {
      if (d.status == 1) {
        // Show non-sticky card discounts
        if (!d.isStickyCardDiscount) {
          let oneCustomizedDiscount = { text: d.name, value: d.id.toString() };
          customizedDiscountOptions.push(oneCustomizedDiscount);
        }
        // Show sticky card discounts only if member has enough points
        else if (d.isStickyCardDiscount &&
          p.order &&
          p.order.patientStickyCardsPoints &&
          p.order.patientStickyCardsPoints >= d.stickyCardPointsNeededToApply) {
          let discountNameToShow = `${d.name} (${t('pos.discountDialog.stickyCard')} - ${d.stickyCardPointsNeededToApply} ${t('pos.discountDialog.points')})`;

          let oneCustomizedDiscount = { text: discountNameToShow, value: d.id.toString() };
          customizedDiscountOptions.push(oneCustomizedDiscount);
        }
      }
    });
    let selectedCustomizedDiscount = this.props.customizedDiscounts.filter(x => x.id.toString() == this.props.posDialogDiscountCustomizedDiscountSelection);
    let selectedCustomizedDiscountAmount = selectedCustomizedDiscount.length > 0 ? selectedCustomizedDiscount[0].value : 0;
    let selectedCustomizedDiscountType = selectedCustomizedDiscount.length > 0 ? selectedCustomizedDiscount[0].customizedDiscountType : 0;

    let alpine = this.props.alpineIQApiKey && this.props.alpineIQDiscounts ? this.props.alpineIQDiscounts.filter(x => x.type == 2 || x.type == 3).length > 0 : false;
    const isSalesPerson = this.props.userRole.includes("SalesPerson") ? true : false
    return (
      <DialogInput
        title={<DialogHeader text={`${t('pos.discountDialog.applyDiscount')} - ${t('common.order')} #` + p.orderId} />}
        modal={true}
        open={p.open}
        autoScrollBodyContent={true}
        contentStyle={dialogStyle}
        className={alpine ? "alpineProduct" : ""}
        actions={[
          <Button
            key={2}
            type="CancelButton"
            name="buttonCancel"
            className="btn-space"
            label={t('common.cancel')}
            onTouchTap={() => this.onClose()} />,
          <Button
            key={1}
            name="addButton"
            label={t('common.apply')}
            className="btnNewBrandPOS"
            primary={true}
            disabled={radioSelected !== '2' && disableOrderDiscount}
            onTouchTap={() => this.applyDiscount()} />
        ]}>
          <div className="row">
            <div className="col-lg-12">
              {(this.props.discountNeedApproval &&
                (!this.props.posDialogDiscountCustomizedDiscountSelection ||
                  this.props.posDialogDiscountCustomizedDiscountSelection.length === 0)) ? (
                <React.Fragment>
                  <br />
                  <div className="alert alert-danger">
                    <p>{t('pos.discountDialog.alertMessage')}</p>
                  </div>
                  <h4 className="purpleText"><b>{t('common.credentialsTitle')}</b></h4>
                  <div className="row">
                    <div className="col-lg-6">
                      <TextInput name={`${p.name}Username`}
                        fullWidth={true}
                        autoComplete="off"
                        label={t('common.mgmtTeamUserName')}
                        floatingLabelText={t('common.mgmtTeamUserName')}
                        hintText={t('common.mgmtTeamUserName')} />
                    </div>
                    <div className="col-lg-6">
                      <TextInput name={`${p.name}Password`}
                        type="password"
                        fullWidth={true}
                        autoComplete="off"
                        label={t('common.mgmtTeamPwd')}
                        floatingLabelText={t('common.mgmtTeamPwd')}
                        hintText={t('common.mgmtTeamPwd')} />
                    </div>
                  </div>
                  <div>
                    <h4 className="purpleText"><b>Or By {t('common.pinCode')}</b></h4>
                    <div className="row">
                      <div className="col-lg-12">
                        <TextInput name={`${p.name}PinCode`} hintText={t('common.password')} fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}

              <div className="row">
                <div className="col-lg-12 discountRadioGroup">
                  <RadioInput groupName={`${p.name}DiscountType`}
                    options={discountOptions}
                    className="rdBtnLabels"
                  />
                </div>
              </div>

              {radioSelected === '2' ? (alpine ? <POSAlpineProductDiscount className="alpineProduct" name="POSProductDiscount" /> : <POSProductDiscount name="POSProductDiscount" />)
                  :
                  radioSelected === '1' && !disableOrderDiscount ?
                    <div className="row">
                      {(!this.props.posDialogDiscountCustomizedDiscountSelection || this.props.posDialogDiscountCustomizedDiscountSelection.length === 0) &&
                        <React.Fragment>
                          <div style={{ fontSize: "18px" }} className="col-lg-12">
                          {t('pos.discountDialog.manualDiscount')}:
                          </div>
                          <div className="col-lg-7" id="POSDiscountAmount">
                            {
                              this.props.isPercentage ? (
                                <React.Fragment>
                                  <MaskedTextInput
                                    fullWidth={true}
                                    name={`${p.name}Percentage`}
                                    floatingLabelText={`${t('pos.discountDialog.amount.label')} (%)`}
                                    label={`${t('pos.discountDialog.amount.label')} (%)`}
                                    hintText={`${t('pos.discountDialog.amount.hintText')} (%)`}
                                    mask="999"
                                    min={0}
                                    max={isSalesPerson ? (p.saleDiscountCap > 0 ? p.saleDiscountCap : 100) : 100} />
                                  {this.getDiscountWarningMessage(p.orderTotal, this.props.manualDiscountPercentage, "percentage")}
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <DecimalInput
                                    name={`${p.name}Amount`}
                                    fullWidth={true}
                                    floatingLabelText={`${t('pos.discountDialog.amount.label')} ($)`}
                                    label={`${t('pos.discountDialog.amount.label')} ($)`}
                                    hintText={`${t('pos.discountDialog.amount.hintText')} ($)`}
                                    min={0}
                                    max={isSalesPerson ? (this.props.saleDiscountCap > 0 ? Math.min(p.orderTotal, p.orderTotal * (this.props.saleDiscountCap / 100)) : p.orderTotal) : p.orderTotal}
                                    required />
                                  {this.getDiscountWarningMessage(p.orderTotal, this.props.manualDiscountAmount, "decimal")}
                                </React.Fragment>
                              )
                            }
                          </div>
                          <div className="col-lg-5">
                            <CheckInput name={`${p.name}IsPercentage`} text={t('pos.discountDialog.isPercentage')} />
                          </div>
                        </React.Fragment>
                      }
                      {p.customizedDiscounts.length > 0 ?
                        <div style={{ fontSize: "18px" }} className="col-lg-12">
                          Customized Discount:
                          {this.getDiscountWarningMessage(p.orderTotal, selectedCustomizedDiscountAmount, this.getDiscountTypeName(selectedCustomizedDiscountType))}
                          {p.stickyCardsEnabled && p.order && p.order.patientStickyCardsPoints > 0 &&
                            <React.Fragment>
                              <p>Current Sticky Cards Points: {p.order.patientStickyCardsPoints}</p>
                            </React.Fragment>
                          }
                          <RadioInput groupName={`${p.name}CustomizedDiscountSelection`}
                            options={customizedDiscountOptions}
                            defaultValue="" 
                            className="customizedRadioGroup"
                          />
                          {

                            p.posDialogDiscountCustomizedDiscountSelection ?
                              <Button
                                key={1}
                                name="addButton"
                                label={t('pos.discountDialog.clearDiscount')}
                                className="btnNewBrandPOS"
                                primary={true}
                                onTouchTap={() => this.clearCustomizedDiscount()}
                              />
                              : ""
                          }
                        </div>
                        : ""
                      }
                    </div>
                    : <div className="row">
                      <div className="col-lg-12">
                        {radioSelected === '3' && p.order && p.order.patientRewardPoints && p.order.patientRewardPoints > this.props.rewardPointsDivider / 100 ?
                          <React.Fragment>
                            <p className="purpleText">
                              ${t('pos.discountDialog.deductMaxWarning', { points: p.order.patientRewardPoints, maxRewardPointsDiscountAmount: maxRewardPointsDiscountAmount})}
                            </p>
                            <DecimalInput
                              name={p.stackDiscountsEnabled ? `POSDiscountRewardAmount` : `${p.name}Amount`}
                              fullWidth={true}
                              floatingLabelText={`${t('pos.discountDialog.amount.label')} ($)`}
                              label={`${t('pos.discountDialog.amount.label')} ($)`}
                              hintText={`${t('pos.discountDialog.amount.hintText')} ($)`}
                              min={0}
                              max={maxDiscountAppliedForOrder}
                              required />
                          </React.Fragment>
                          : ""}

                      </div>
                    </div>}
              <div className="row">
                <div className="col-lg-12">
                  <br />
                  {this.props.radioSelected == 1 &&
                    <TextInput
                      name={`${p.name}Notes`}
                      label={t('common.notes')}
                      hintText={t('common.notes')}
                      fullWidth={true}
                    />}
                </div>
              </div>
            </div>
          </div>
      </DialogInput>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    model: selectPOSDiscountModel(state, ownProps.name),
    deviceKeyName: state.common.applicationSettings.deviceKeyName,
    isPercentage: state.form[`${ownProps.name}IsPercentage`],
    saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
    saveError: state.form[`${ownProps.name}SaveError`],
    radioSelected: state.form[`${ownProps.name}DiscountType`],
    manualDiscountAmount: state.form[`posDialogDiscountAmount`],
    manualDiscountPercentage: state.form[`posDialogDiscountPercentage`],
    productDiscounts: selectDiscountProducts(state.form, 'POSProductDiscount', state.entity.posOrder ? state.entity.posOrder.products : [], state.entity.priceMatchRows),
    order: state.entity.posOrder,
    rewardPointsDivider: state.common.applicationSettings.rewardPointsDivider,
    discountNeedApproval: state.common.applicationSettings.discountNeedApproval,
    hvcMonthlySpent: state.common.applicationSettings.hvcMonthlySpent,
    hvcRewardPointsDivider: state.common.applicationSettings.hvcRewardPointsDivider,
    branchId: state.common.branchId,
    isMedical: state.common.applicationSettings.isMedical,
    customizedDiscounts: state.entity.customizedDiscounts || [],
    posDialogDiscountCustomizedDiscountSelection: state.form.posDialogDiscountCustomizedDiscountSelection,
    pinCode: state.form[`${ownProps.name}PinCode`],
    province: state.common.store.provinceState,
    hideRewards: state.common.applicationSettings.hideRewards || false,
    alpineIQDiscounts: state.entity.alpineIQwallet || "",
    alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || "",
    alpineIQPoints: state.entity.alpineIQPoints || 0,
    saleDiscountCap: state.common.applicationSettings.salesPersonDiscountThreshold ? state.common.applicationSettings.salesPersonDiscountThreshold : 0,
    userRole: state.common.authenticatedUser.roles,
    stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
    POSDiscountRewardAmount: state.form.POSDiscountRewardAmount,
    rewardPointNotes: state.form.posDialogDiscountNotes || "",
    stickyCardsEnabled: state.common.applicationSettings.stickyCardsEnabled,
    isHighTide: state.common.applicationSettings.isHighTide,
    isInspired: state.common.applicationSettings.isInspired
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    discountOrder: (model) => dispatch(discountOrder(model, ownProps.name)),
    discountProductsOrder: (model) => dispatch(discountProductsOrder(model, ownProps.name)),
    getCustomizedDiscounts: (model) => dispatch(getCustomizedDiscounts(model)),
    showSnackbar: (message) => dispatch(showSnackbar(message)),
    showError: (message) => dispatch(showError(message)),
    formError: (name, error) => dispatch(formError(name, error)),
    clearFormErrors: () => dispatch(clearFormErrors()),
    initializeStoreDiscount: () => dispatch(initializeStoreDiscount(ownProps.name, 'POSProductDiscount'))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSDiscountDialog))